const handleSearch = () => {
  if (window.innerWidth > 767) {
    const searchEl = document.querySelector("#header .search");
    const navigationEl = document.querySelector("#header .navigation-in");
    if (!searchEl || !navigationEl) return;
    navigationEl.appendChild(searchEl);
  }
};
const handleTopMenu = () => {
  const topNavMenu = document.querySelector(".top-navigation-menu");
  const headerTop = document.querySelector("#header .header-top");
  if (!topNavMenu || !headerTop) return;
  headerTop.prepend(topNavMenu);
};

const handleAccBtn = () => {
  const accBtn =
    document.querySelector(".top-nav-button-account") ||
    document.querySelector(".top-nav-button-login");
  const navigationBtns = document.querySelector(".navigation-buttons");
  if (!accBtn || !navigationBtns) return;
  navigationBtns.prepend(accBtn);
};

const handleSubmenu = () => {
  const menuLvL2s = document.querySelectorAll(".menu-level-2");
  if (!menuLvL2s.length) return;
  for (let i = 0; i < menuLvL2s.length; i++) {
    const menuLvL2 = menuLvL2s[i];
    const parentLi = menuLvL2.closest("li");
    const menuLvL2Helper = document.createElement("div");
    menuLvL2Helper.classList.add("menu-level-2-helper");
    parentLi.appendChild(menuLvL2Helper);
    menuLvL2Helper.appendChild(menuLvL2);
    const mobileMenuBack = document.createElement("button");
    mobileMenuBack.classList.add("mobile-menu-back");
    mobileMenuBack.innerHTML = '<span class="sr-only">Zpět</span>';
    menuLvL2Helper.prepend(mobileMenuBack);
    mobileMenuBack.addEventListener("click", () => {
      document.body.classList.remove("submenu-visible");
      setTimeout(() => {
        const exp = mobileMenuBack.closest(".exp");
        if (exp) exp.classList.remove("exp");
      }, 150);
    });
  }
  const menuLvL2Images = document.querySelectorAll(
    ".menu-level-2 .menu-image img"
  );
  if (!menuLvL2Images.length) return;
  for (let i = 0; i < menuLvL2Images.length; i++) {
    const img = menuLvL2Images[i];
    img.setAttribute(
      "data-src",
      img.getAttribute("data-src").replace("/thumb/", "/orig/")
    );
    img.src = img.src.replace("/thumb/", "/orig/");
  }
};

const handleMenuHelper = () => {
  const menuHelper = document.querySelector(".menu-helper");
  const menuLvl1 = document.querySelector(".menu-level-1");
  if (!menuHelper || !menuLvl1) return;
  menuLvl1.parentElement.insertBefore(menuHelper, menuLvl1.nextElementSibling);
};

const handleMobileHeader = () => {
  if (window.innerWidth > 767) return;
  const topMenu = document.querySelector(".top-navigation-menu");
  const navigation = document.querySelector("#navigation");
  if (topMenu && navigation) navigation.appendChild(topMenu);

  const menuTrigger = document.querySelector(
    '.toggle-window[data-target="navigation"]'
  );
  const headerTop = document.querySelector("#header .header-top");
  if (menuTrigger && headerTop) headerTop.appendChild(menuTrigger);
};

const computeHeaderHeight = () => {
  const header = document.getElementById("header");
  if (!header) return;
  document.documentElement.style.setProperty(
    "--header-height",
    `${header.offsetHeight}px`
  );
};

const handleFavTags = () => {
  const allLinks = document.querySelectorAll(
    ".menu-level-1 a > b, .menu-level-1 a > span"
  );
  allLinks.forEach((link) => {
    link.innerHTML = link.innerHTML.replace("FAV", "");
  });

  const breadcrumbLinks = document.querySelectorAll(
    '.breadcrumbs [itemprop="name"]'
  );
  breadcrumbLinks.forEach((link) => {
    link.innerHTML = link.innerHTML.replace("FAV", "");
  });
};

const headerInit = () => {
  // handleSearch();
  // handleTopMenu();
  handleAccBtn();
  // handleSubmenu();
  handleMenuHelper();
  handleMobileHeader();
  computeHeaderHeight();
  handleFavTags();
};

export { headerInit };
